import { useMemo } from "react";
import { get } from "lodash";
import { useQuery } from "@tanstack/react-query";

import { queryClient } from "App";
import { addResizedColumns } from "./useTableConfig";
import { REVENUE_OPPORTUNITY_STATUS_PRESETS_TABLE_CONSTANTS } from "routes/revenue_opportunity_status_presets/RevenueOpportunityStatusPresetsTableV3";
import UserService from "services/User";
import {
  getRevenueOpportunityStatusPresetsTableColumns,
  getRevenueOpportunityStatusPresetsTableFilters,
} from "routes/revenue_opportunity_status_presets/RevenueOpportunityStatusPresetsTableColumnsAndFilters";

export const invalidateRevenueOpportunityStatusPresetsTableQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [REVENUE_OPPORTUNITY_STATUS_PRESETS_TABLE_CONSTANTS.queryKey],
  });
};

export const useRevenueOpportunityStatusPresetsTable = ({ tableName }) => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const filters = useMemo(() => {
    return getRevenueOpportunityStatusPresetsTableFilters();
  }, []);

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getRevenueOpportunityStatusPresetsTableColumns();

    const presetsTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: presetsTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableName, tableSettings, isTableSettingsFetched]);

  return { filters, columns };
};
